module.exports = __webpack_public_path__ + "img/14.d31db8bb.jpg";